var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token)?_c('div',[_c('wallets')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }